import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Layout from "../../components/layout";
import { faMoneyBill1 } from "@fortawesome/free-regular-svg-icons";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import { API_BASE_URL } from "../../utils/useFetch";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const Feedback = () => {
  const [isSendingData, setIsSendingData] = useState(false);
  const [message, setMessage] = useState("");
  const [feedBackType, setFeedBackType] = useState("پیشنهاد یا انتقاد");
  const userData = useSelector((state: RootState) => state.user.userInfo);

  const fetchSubmit = useCallback(async (fullOrder: any) => {
    const _formData = new FormData();
    _formData.append("phone", fullOrder.phone);
    _formData.append("code", fullOrder.code);
    _formData.append("title", fullOrder.title);
    _formData.append("content", fullOrder.content);

    const response = await fetch(API_BASE_URL + "suggest", {
      method: "POST",
      body: _formData,
    });

    return response.json();
  }, []);

  const handleSubmit = () => {
    if (message.length < 5) {
      toast.error("لطفا متن پیام خود را بنویسید ");
      return;
    }

    setIsSendingData(true);

    const fullOrder = {
      phone: userData.mobile,
      code: userData.code,
      title: feedBackType,
      content: message,
    };

    fetchSubmit(fullOrder)
      .then((response) => {
        if (response) {
          toast.success("پیشنهاد شما با موفقیت ارسال شد");
          setMessage("");
        } else {
          toast.error(response.message + " gertY");
        }
        setIsSendingData(false);
      })
      .catch((error) => {
        setIsSendingData(false);
        toast.error(error.toString());
      });
  };
  return (
    <Layout>
      <section className='container mx-auto flex '>
        <div className='flex-1 border bg-white'>
          <div className='p-2 font-bold border-b border-solid'>
            انتقادات و پیشنهادات
          </div>
          <div className='p-4'>
            <div className='pt-4 pr-4 lg:hidden'>
              <FontAwesomeIcon icon={faMoneyBill1} /> موضوع
            </div>
            <div className='p-4 border-b flex'>
              <div className='w-40 hidden lg:block'>
                <FontAwesomeIcon icon={faMoneyBill1} /> موضوع
              </div>
              <div>
                <select
                  onChange={(e) => setFeedBackType(e.target.value)}
                  className='border rounded py-1 px-4'
                >
                  <option value='پیشنهاد یا انتقاد'>پیشنهاد یا انتقاد</option>
                  <option value='درخواست ویژگی جدید'>درخواست ویژگی جدید</option>
                  <option value='گزارش خطا'>گزارش خطا</option>
                  <option value='شکایت'>شکایت</option>
                </select>
              </div>
            </div>
            <textarea
              rows={3}
              placeholder='متن پیام'
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className='border rounded w-full p-2'
            />

            <button
              className=' bg-rose-900 text-white p-4 rounded'
              onClick={handleSubmit}
            >
              {isSendingData ? (
                <>
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    className='rotate-animation'
                  />
                </>
              ) : (
                <> ارسال</>
              )}
            </button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Feedback;
